
interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-auto">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3">
            <div className="relative" style={{ height: '127px', width: '328px' }}>
              <img
                src="https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/850ddcc7d15e52238c9cc8bfc6401426.png"
                alt="Akten Inc Logo"
                className={`logo-dark absolute top-0 left-0 object-contain transition-opacity duration-300 ${
                  isScrolled ? 'opacity-100' : 'opacity-0'
                }`}
                style={{ height: '127px', width: 'auto' }}
              />
              <img
                src="https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/7305daf35cd38cde87aaf77f292ac5ef.png"
                alt="Akten Inc Logo"
                className={`logo-light absolute top-0 left-0 object-contain transition-opacity duration-300 ${
                  isScrolled ? 'opacity-0' : 'opacity-100'
                }`}
                style={{ height: '127px', width: 'auto' }}
              />
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#about"
              className={`text-sm font-medium transition-colors hover:opacity-70 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About Us
            </a>
            <a
              href="#services"
              className={`text-sm font-medium transition-colors hover:opacity-70 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Services
            </a>
            <a
              href="#partnership"
              className={`text-sm font-medium transition-colors hover:opacity-70 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Partnership
            </a>
            <a
              href="#contact"
              className={`px-6 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? '' : 'bg-white/10 backdrop-blur-sm hover:bg-white/20'
              }`}
            >
              Become a Supplier
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
